import script from "./TooltipModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipModal.vue?vue&type=script&setup=true&lang=js"

import "./TooltipModal.vue?vue&type=style&index=0&id=e8d42050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8d42050"]])

export default __exports__